import { render, staticRenderFns } from "./ListaSolicitacoesColaboradores.vue?vue&type=template&id=dcf0281a&scoped=true&"
import script from "./ListaSolicitacoesColaboradores.vue?vue&type=script&lang=js&"
export * from "./ListaSolicitacoesColaboradores.vue?vue&type=script&lang=js&"
import style0 from "./ListaSolicitacoesColaboradores.vue?vue&type=style&index=0&id=dcf0281a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf0281a",
  null
  
)

component.options.__file = "ListaSolicitacoesColaboradores.vue"
export default component.exports